import createListDataFetchManagementStoreSlice from '../../../modules/utilities/store/slices/listDataFetchManagement'

const sliceName = 'userManagementExperience.listExport'

const UserManagementUserListExportSlice = createListDataFetchManagementStoreSlice(
  sliceName
)

export default UserManagementUserListExportSlice
